import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Subscription } from 'rxjs';
import { ContactDocumentType, ContactDocumentTypeToString } from '../../model/const/documentEnums';
import { SelectionItem } from '../../../core/component/select/select.component';
import { ContactDocumentService } from '../../service/data/contact-document.service';
import { Contact } from '../../model/contact';
import { ContactDocument } from '../../model/contact-document';

@Component({
    selector: 'app-contact-document-form',
    templateUrl: './contact-document-form.component.html',
    styleUrls: ['./contact-document-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactDocumentFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: ContactDocumentService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _renderer: Renderer2
  ) {}

  private _subscription: Subscription = new Subscription();
  dataContext: Contact;
  form: FormGroup;

  connectionTypes: SelectionItem[];

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.connectionTypes = [
      ContactDocumentType.General,
      ContactDocumentType.Agreement,
      ContactDocumentType.DisturbanceLetter,
      ContactDocumentType.WarningLetter,
      ContactDocumentType.Photo,
    ].map(t => new SelectionItem(ContactDocumentTypeToString(t), t));

    this.form = this._fb.group({
      caption: this._fcf.createMandatory('LEASE_AGREEMENT_DOCUMENT.CAPTION', ''),
      connectionType: this._fcf.createMandatory('DOCUMENT.DOCUMENT_TYPE', ContactDocumentType.General),
      document: this._fcf.createMandatory('', null),
      contactId: this._fcf.createHidden(this.dataContext.id),
    });
  }

  onFileChange(files: FileList) {
    if (files && files.length === 1) {
      this.form.controls['document'].setValue(files[0]);
      this.form.controls['caption'].setValue(files[0].name.substr(0, files[0].name.lastIndexOf('.')));
    } else {
      this.form.controls['caption'].reset();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this._subscription.add(
        this._dataService.add(Object.assign(new ContactDocument(), this.form.value)).subscribe(() => this._actionService.complete(true))
      );
    }
  }
}
